import {
  UserReport,
  ChartData,
  UserActiveData,
  TopMenuData,
  PktData,
  MaterialAccess,
  AccessRateChartsData,
} from '@/domain/entities/UserReport'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class UserReportDataMapper extends BaseResponseMapper {
  public convertUserReportFromApi(result: AxiosResponse<any>): UserReport {
    const { data } = result
    return new UserReport(
      data.success,
      data.message,
      data.data.top_menu.items.map(
        (menu) =>
          new TopMenuData(menu.id, menu.name, menu.key, menu.value, menu.color)
      ),
      data.data.charts.items.map(
        (chart) => new ChartData(chart.periode, chart.total)
      ),
      data.data.access_rate_charts.items
        ? data.data.access_rate_charts.items.map(
            (val) =>
              new AccessRateChartsData(
                val.month,
                val.percentage,
                val.total_user_access,
                val.total_user_visit
              )
          )
        : [],
      data.data.most_active_user.items.map(
        (user) =>
          new UserActiveData(
            user.id,
            user.sales_code,
            user.sales_name,
            user.dealer_name,
            user.dealer_code,
            user.dealer_city,
            user.total_access,
            user.position,
            user.last_access
          )
      ),
      data.data.pkt_data.items.map(
        (pkt) =>
          new PktData(
            pkt.id,
            pkt.sales_code,
            pkt.sales_name,
            pkt.dealer_name,
            pkt.total_report
          )
      ),
      data.data.material_access.items.map(
        (mat) =>
          new MaterialAccess(
            mat.category,
            mat.total_views,
            mat.file_code,
            mat.title
          )
      )
    )
  }
}
